import { render } from "./PasMyAppraisal.vue?vue&type=template&id=9ede9d24&scoped=true"
import script from "./PasMyAppraisal.vue?vue&type=script&lang=js"
export * from "./PasMyAppraisal.vue?vue&type=script&lang=js"

import "./PasMyAppraisal.vue?vue&type=style&index=0&id=9ede9d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ede9d24"]])

export default __exports__